import * as React from 'react'

import { useUniqueDef } from '../../utils/useUniqueDef'

// Do not add new / additional icons here
// Prefer @arcade/web/icons/react

const Bank = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.65 4.147a1.5 1.5 0 0 1 .7 0c.197.047.42.17 1.48.876l7.838 5.225a1.5 1.5 0 0 0 1.664-2.496l-7.837-5.225-.168-.112c-.793-.53-1.49-.997-2.278-1.186a4.5 4.5 0 0 0-2.098 0c-.787.19-1.485.655-2.278 1.186l-.168.112L.668 7.752a1.5 1.5 0 1 0 1.664 2.496l7.837-5.225c1.06-.707 1.284-.829 1.481-.876ZM7.5 12.5a1.5 1.5 0 0 0-3 0v8a1.5 1.5 0 0 0 3 0v-8Zm6 0a1.5 1.5 0 1 0-3 0v8a1.5 1.5 0 0 0 3 0v-8ZM18 11a1.5 1.5 0 0 1 1.5 1.5v8a1.5 1.5 0 1 1-3 0v-8A1.5 1.5 0 0 1 18 11Z"
      fill="currentColor"
    />
  </svg>
)

const Check = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#a)" stroke="currentColor" strokeWidth="3">
      <path d="M1.5 7A2.5 2.5 0 0 1 4 4.5h16A2.5 2.5 0 0 1 22.5 7v10a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 17V7z" />
      <path strokeLinecap="round" d="M7 13.5h4M16 13.5h1" />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
)

const CheckMark = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M1.5 6.5L5.5 10.5L14.5 1.5"
      stroke="currentColor"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const CheckmarkCircle = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_3669_226640)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM17.9357 9.68566C18.5214 9.09987 18.5214 8.15013 17.9357 7.56434C17.3499 6.97855 16.4001 6.97855 15.8143 7.56434L10.125 13.2537L8.18566 11.3143C7.59987 10.7286 6.65013 10.7286 6.06434 11.3143C5.47855 11.9001 5.47855 12.8499 6.06434 13.4357L9.06434 16.4357C9.65013 17.0214 10.5999 17.0214 11.1857 16.4357L17.9357 9.68566Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3669_226640">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

const Info = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 9a7 7 0 1114 0A7 7 0 012 9zM0 9a9 9 0 1118 0A9 9 0 010 9zm10.125 3.375a1.125 1.125 0 01-2.25 0V9a1.125 1.125 0 012.25 0v3.375zM9 4.5a1.125 1.125 0 110 2.25A1.125 1.125 0 019 4.5z"
      fill="currentColor"
    />
  </svg>
)

const Help = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12ZM24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM12.0574 6C14.4249 6 16.0465 7.28108 16.0465 9.42162C16.0465 11.0326 15.0442 11.7852 14.2111 12.4108C13.6185 12.8558 13.1114 13.2366 13.1114 13.8162C13.1114 13.9622 12.9006 14.0595 12.5438 14.0595H11.0844C10.7276 14.0595 10.5168 13.9946 10.5168 13.8811C10.5168 12.5311 11.3893 11.8218 12.1722 11.1854C12.8093 10.6675 13.3871 10.1978 13.3871 9.47027C13.3871 8.61081 12.6574 8.17297 11.7168 8.17297C11.0357 8.17297 10.4844 8.4 10.0303 8.74054C9.72222 8.96757 9.44655 8.93514 9.23573 8.64324L8.63574 7.83243C8.42492 7.54054 8.45736 7.24865 8.74925 7.03784C9.57628 6.45405 10.6628 6 12.0574 6ZM11.8465 14.8865C12.6898 14.8865 13.4033 15.5838 13.4033 16.4432C13.4033 17.2865 12.6898 18 11.8465 18C11.0033 18 10.2898 17.2865 10.2898 16.4432C10.2898 15.5838 11.0033 14.8865 11.8465 14.8865Z"
      fill="currentColor"
    />
  </svg>
)

const NavHelp = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      d="M15.232 20.934c1.144 0 2.08.936 2.08 2.106 0 1.144-.936 2.08-2.08 2.08-1.144 0-2.054-.936-2.054-2.08 0-1.17.91-2.106 2.054-2.106zM10.333 8.15c.016-.153.101-.305.28-.449a8.514 8.514 0 015.165-1.721c1.75 0 3.227.489 4.264 1.374 1.036.883 1.642 2.167 1.642 3.778 0 2.189-1.191 3.36-2.407 4.329-.15.12-.3.236-.45.352-.452.351-.89.69-1.24 1.056-.468.49-.791 1.04-.791 1.751 0 .104-.05.19-.157.256-.112.068-.286.112-.523.112H14.27c-.254 0-.431-.001-.547-.035-.055-.016-.085-.036-.102-.058-.017-.022-.031-.056-.031-.119 0-2.059 1.158-3.216 2.344-4.227.113-.096.226-.192.34-.286.476-.4.94-.79 1.306-1.213.456-.528.768-1.12.768-1.866 0-.756-.292-1.37-.817-1.794-.524-.421-1.27-.646-2.17-.646-1.247 0-2.23.426-3.102 1.113-.197.147-.367.203-.514.188-.145-.016-.291-.105-.437-.299l-.806-1.091c-.133-.182-.185-.352-.17-.506z"
      fill="currentColor"
    />
    <circle cx={11.455} cy={8.765} r={1.355} fill="currentColor" />
  </svg>
)
const Ellipsis = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.667 18.667a2.668 2.668 0 010-5.334 2.668 2.668 0 010 5.334zm9.333 0a2.668 2.668 0 010-5.334 2.668 2.668 0 010 5.334zM22.667 16A2.668 2.668 0 0028 16a2.668 2.668 0 00-5.333 0z"
      fill="currentColor"
    />
  </svg>
)

const Failed = ({ color = '#F84049', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <rect width="24" height="24" rx="12" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.543 8.028a1.071 1.071 0 10-1.515 1.515L10.485 12l-2.457 2.457a1.072 1.072 0 001.515 1.515L12 13.515l2.457 2.457a1.072 1.072 0 001.515-1.515L13.515 12l2.457-2.457a1.071 1.071 0 00-1.515-1.515L12 10.485 9.543 8.028z"
      fill="#fff"
    />
  </svg>
)

const Verification = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.01 17.59c1.983-2.402 3.799-5.988 3.976-10.815a6.54 6.54 0 00-.216-.172c-.655-.5-1.644-1.093-2.797-1.675a30.542 30.542 0 00-3.338-1.447c-.975-.35-1.493-.452-1.61-.475A.56.56 0 0112 3a.56.56 0 01-.025.005c-.117.023-.635.125-1.61.475a30.54 30.54 0 00-3.338 1.447C5.874 5.51 4.885 6.103 4.23 6.603c-.083.063-.155.12-.216.172.177 4.828 1.993 8.413 3.975 10.816 1.053 1.276 2.138 2.2 3.019 2.781.413.274.752.452.992.556.24-.104.579-.282.992-.556.88-.582 1.966-1.505 3.019-2.781zM3.71 7.063l.007-.009a.278.278 0 01-.007.01zm16.575-.009l.007.01a.269.269 0 01-.007-.01zM12 24c2.2 0 11-6 11-18 0-2-8.8-6-11-6C9.8 0 1 4 1 6c0 12 8.8 18 11 18zm4.852-14.064a1.5 1.5 0 10-2.121-2.122l-4.19 4.19L9.27 10.73a1.5 1.5 0 10-2.121 2.121l2.333 2.334a1.5 1.5 0 002.121 0l5.25-5.25z"
      fill="currentColor"
    />
  </svg>
)

const ChevronDown = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      d="m18 10-6 6-6-6"
      stroke="currentColor"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Dollar = (props: React.SVGAttributes<SVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M9.71509 5.43153C9.02962 5.43153 8.41652 5.58721 7.98045 5.87107C7.54948 6.15162 7.29231 6.55484 7.29231 7.07342C7.29231 7.42179 7.41567 7.68775 7.63749 7.90623C7.86481 8.13014 8.20103 8.30912 8.63147 8.46185L8.63297 8.46238C9.0298 8.60748 9.50958 8.7301 10.0306 8.86326C10.1312 8.88897 10.2334 8.91508 10.3368 8.94181C10.97 9.10556 11.643 9.29156 12.2575 9.55272C12.8718 9.81378 13.4391 10.1546 13.8533 10.6349C14.271 11.119 14.5255 11.7364 14.5255 12.532C14.5255 13.6016 14.0756 14.5367 13.2624 15.2012C12.4515 15.8638 11.2893 16.25 9.87046 16.25C8.07554 16.25 6.3788 15.5849 5.2578 14.204C5.08362 13.9894 5.1476 13.6768 5.37769 13.5237L6.07979 13.0565C6.3113 12.9025 6.62162 12.9696 6.80127 13.1819C7.58425 14.1069 8.71074 14.5685 9.95678 14.5685C10.7957 14.5685 11.4653 14.3685 11.9206 14.0318C12.3713 13.6986 12.6212 13.2257 12.6212 12.6471C12.6212 12.3411 12.5513 12.1015 12.4278 11.9053C12.3036 11.7078 12.1183 11.5435 11.8712 11.3998C11.3701 11.1084 10.65 10.9201 9.76386 10.705C8.75671 10.4836 7.66911 10.2118 6.83311 9.69586C5.98468 9.17224 5.38804 8.39159 5.38804 7.17207C5.38804 6.0446 5.91026 5.18182 6.72528 4.60668C7.53503 4.03525 8.62862 3.75 9.78415 3.75C11.4029 3.75 12.8826 4.34246 13.9763 5.49228C14.1742 5.7003 14.1251 6.03067 13.8904 6.19593L13.2412 6.65292C13.0267 6.8039 12.7342 6.76081 12.5473 6.57683C11.7914 5.833 10.8073 5.43153 9.71509 5.43153Z"
      fill={props.fill || 'currentColor'}
    />
    <rect x="9.16797" y="2.29102" width="1.66667" height="15.4167" rx="0.25" fill={props.fill || 'currentColor'} />
  </svg>
)

const CashDollar = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.727 6.264c1.71 0 3.349.693 4.42 1.643.27.24.676.24.93-.018l1.274-1.293a.664.664 0 0 0-.031-.968 10.073 10.073 0 0 0-3.416-1.92l.4-1.903A.667.667 0 0 0 15.65 1h-2.462a.668.668 0 0 0-.653.528l-.36 1.693c-3.273.163-6.047 1.796-6.047 5.147 0 2.9 2.295 4.144 4.718 5.005 2.295.86 3.506 1.18 3.506 2.39 0 1.243-1.211 1.976-2.997 1.976-1.627 0-3.332-.537-4.656-1.841a.664.664 0 0 0-.934-.002l-1.369 1.35a.671.671 0 0 0 .004.96c1.068 1.036 2.42 1.786 3.962 2.206l-.376 1.763a.668.668 0 0 0 .649.806l2.466.019a.667.667 0 0 0 .657-.53l.356-1.695c3.92-.242 6.318-2.372 6.318-5.49 0-2.868-2.39-4.08-5.291-5.068-1.658-.606-3.093-1.02-3.093-2.263 0-1.21 1.34-1.69 2.678-1.69Z"
      fill="currentColor"
    />
  </svg>
)

const Pencil = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.751 1.831a2.012 2.012 0 00-2.529.258l-.711.711L2 16.311v5.186c0 .278.225.503.503.503h5.186l13.51-13.511.712-.711a2.011 2.011 0 000-2.844l-2.845-2.845a2.021 2.021 0 00-.315-.258zm-2.54 4.513l1.445 1.446L6.446 19H5v-1.446l11.21-11.21z"
      fill="currentColor"
    />
  </svg>
)

const Trash = (props: React.SVGAttributes<SVGElement>) => {
  const { id, url } = useUniqueDef()
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M5.625 6.625h12.75V16A3.375 3.375 0 0115 19.375H9A3.375 3.375 0 015.625 16V6.625z"
        stroke="currentColor"
        strokeWidth="2.25"
      />
      <mask id={id} maskUnits="userSpaceOnUse" x="3" y="5" width="18" height="3">
        <path fillRule="evenodd" clipRule="evenodd" d="M3 5.5h18v2.25H3V5.5z" fill="#fff" />
      </mask>
      <g mask={url}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 7a1.5 1.5 0 011.5-1.5h15A1.5 1.5 0 0121 7v1.5a1.5 1.5 0 01-1.5 1.5h-15A1.5 1.5 0 013 8.5V7z"
          fill="currentColor"
        />
      </g>
      <path fillRule="evenodd" clipRule="evenodd" d="M10.5 5.5a1.5 1.5 0 013 0h-3z" fill="currentColor" />
      <rect x="9" y="9" width="2" height="7" rx="1" fill="currentColor" />
      <rect x="13" y="9" width="2" height="7" rx="1" fill="currentColor" />
    </svg>
  )
}

const Plus = (props: React.SVGAttributes<SVGElement>) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.5 5.5a1.5 1.5 0 00-3 0v5h-5a1.5 1.5 0 000 3h5v5a1.5 1.5 0 003 0v-5h5a1.5 1.5 0 000-3h-5v-5z"
      fill="currentColor"
    />
  </svg>
)

const Minus = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="23" height="5" viewBox="0 0 23 5" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M2.23291 2.97681H20.3597"
      stroke="currentColor"
      strokeWidth="4.02773"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const ErrorIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 12a9 9 0 11-18 0 9 9 0 0118 0zm3 0c0 6.627-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0s12 5.373 12 12zM10.5 7.5a1.5 1.5 0 013 0V12a1.5 1.5 0 01-3 0V7.5zM12 18a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0112 18z"
      fill="currentColor"
    />
  </svg>
)
const LockCircle = ({ color = '#00D64F', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="2.5em" height="2.5em" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="20" cy="20" r="20" fill={color} />
    <rect x="12" y="18" width="16" height="10" rx="3" fill="#fff" />
    <path d="M16.5 16a3.5 3.5 0 117 0v3.5h-7V16z" stroke="#fff" strokeWidth="3" />
  </svg>
)

const Lock = ({ color = '#666666', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4.5" y="10" width="16" height="10" rx="3" fill={color} />
    <path d="M9 8C9 6.067 10.567 4.5 12.5 4.5C14.433 4.5 16 6.067 16 8V11.5H9V8Z" stroke={color} strokeWidth="3" />
  </svg>
)

const AlertIcon = ({ color = '#666666', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width={56} height={56} rx={28} fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 14.667A3.333 3.333 0 0024.667 18v10a3.333 3.333 0 006.666 0V18A3.333 3.333 0 0028 14.667zM24.667 38a3.334 3.334 0 006.666 0 3.334 3.334 0 00-6.666 0z"
      fill={props.stroke || '#fff'}
    />
  </svg>
)

const File = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.27 6.184c-.436.856-.436 1.976-.436 4.216v11.2c0 2.24 0 3.36.435 4.216a4 4 0 001.749 1.748C8.873 28 9.993 28 12.233 28h8.534c2.24 0 3.36 0 4.216-.436a4 4 0 001.748-1.748c.436-.856.436-1.976.436-4.216v-8.282c0-.979 0-1.468-.11-1.928a4.001 4.001 0 00-.48-1.157c-.247-.403-.593-.749-1.285-1.44l-2.917-2.918c-.692-.692-1.038-1.038-1.442-1.286a4 4 0 00-1.156-.478C19.317 4 18.827 4 17.85 4h-5.616c-2.24 0-3.36 0-4.215.436a4 4 0 00-1.749 1.748zm4.897 5.815c0-.737.597-1.334 1.333-1.334h5.334a1.333 1.333 0 110 2.667H12.5a1.333 1.333 0 01-1.333-1.333zm0 6.666c0-.736.597-1.333 1.333-1.333h8a1.333 1.333 0 010 2.667h-8a1.333 1.333 0 01-1.333-1.334z"
      fill="currentColor"
    />
  </svg>
)

const Share = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.94 6.44a1.5 1.5 0 1 0 2.12 2.12l2.44-2.439V15.5a1.5 1.5 0 0 0 3 0V6.121l2.44 2.44a1.5 1.5 0 0 0 2.12-2.122l-5-5a1.5 1.5 0 0 0-2.12 0l-5 5ZM5.5 14.5a1.5 1.5 0 0 0-3 0v3A5.5 5.5 0 0 0 8 23h8a5.5 5.5 0 0 0 5.5-5.5v-3a1.5 1.5 0 0 0-3 0v3A2.5 2.5 0 0 1 16 20H8a2.5 2.5 0 0 1-2.5-2.5v-3Z"
      fill="currentColor"
    />
  </svg>
)

const Menu = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="26" height="20" viewBox="0 0 26 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0.320312 1.57493C0.320312 0.814066 0.937113 0.197266 1.69797 0.197266H23.7406C24.5014 0.197266 25.1182 0.814066 25.1182 1.57493C25.1182 2.33579 24.5014 2.95259 23.7406 2.95259H1.69797C0.937113 2.95259 0.320312 2.33579 0.320312 1.57493ZM0.320312 9.84055C0.320312 9.07969 0.937113 8.46289 1.69797 8.46289H23.7406C24.5014 8.46289 25.1182 9.07969 25.1182 9.84055C25.1182 10.6014 24.5014 11.2182 23.7406 11.2182H1.69797C0.937113 11.2182 0.320312 10.6014 0.320312 9.84055ZM1.69797 16.7285C0.937113 16.7285 0.320312 17.3453 0.320312 18.1062C0.320312 18.867 0.937113 19.4838 1.69797 19.4838H23.7406C24.5014 19.4838 25.1182 18.867 25.1182 18.1062C25.1182 17.3453 24.5014 16.7285 23.7406 16.7285H1.69797Z"
      fill="currentColor"
    />
  </svg>
)

const NoFees = ({ color = '#333', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="7.5" y="4.5" width="9" height="15" rx="4.5" stroke={color} strokeWidth="3" />
    <path d="M21 3 3 21" stroke={color} strokeWidth="3" strokeLinecap="round" />
  </svg>
)

const CashAppTaxes = ({ color = '#00D54B', height, width, ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="165" height="21" viewBox="0 0 165 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.6926 4.84991C12.5643 4.9277 12.4116 4.95473 12.2645 4.92572C12.1173 4.8967 11.9863 4.81372 11.8972 4.69307C11.4591 4.06412 10.8712 3.55418 10.1867 3.2093C9.50211 2.86442 8.74245 2.69546 7.97627 2.71767C4.9889 2.71767 3.1554 5.08142 3.1554 8.45715C3.1554 11.8329 5.02251 14.2414 8.00987 14.2414C8.78629 14.26 9.55459 14.08 10.242 13.7187C10.9295 13.3573 11.5133 12.8265 11.9383 12.1764C12.0232 12.0542 12.1509 11.9684 12.2962 11.9359C12.4414 11.9033 12.5935 11.9266 12.7224 12.0009L14.1415 12.8224C14.2189 12.8617 14.287 12.9173 14.3411 12.9853C14.3952 13.0532 14.4341 13.1321 14.455 13.2164C14.4759 13.3007 14.4784 13.3886 14.4623 13.474C14.4462 13.5593 14.4119 13.6402 14.3618 13.7112C13.668 14.751 12.7217 15.5976 11.6113 16.1717C10.501 16.7458 9.26309 17.0286 8.01361 16.9936C3.23756 16.9936 0 13.5282 0 8.47582C0 3.42343 3.23756 0.00289965 7.94266 0.00289965C9.1713 -0.031217 10.3896 0.236164 11.491 0.78167C12.5924 1.32718 13.5435 2.13419 14.2609 3.13217C14.3103 3.19938 14.3452 3.27601 14.3637 3.35729C14.3822 3.43858 14.3838 3.52279 14.3684 3.60472C14.353 3.68665 14.3209 3.76453 14.2742 3.83356C14.2274 3.90258 14.167 3.96126 14.0966 4.00597L12.6926 4.84991Z"
      fill={color}
    />
    <path
      d="M23.1331 16.0784V15.3913C22.3863 16.3548 21.3444 16.9522 19.6678 16.9522C17.1883 16.9522 15.4668 15.5967 15.4668 13.218C15.4668 10.2568 18.1069 9.74893 19.735 9.52115C21.4826 9.26722 22.9726 9.14773 22.9726 8.00506C22.9726 6.99309 21.8038 6.72049 20.8142 6.72049C19.6783 6.73937 18.5623 7.02189 17.5542 7.54575C17.4843 7.5842 17.4072 7.60804 17.3278 7.61585C17.2484 7.62366 17.1681 7.61527 17.092 7.59118C17.0159 7.56709 16.9455 7.5278 16.885 7.47571C16.8245 7.42361 16.7753 7.35979 16.7402 7.28809L16.2286 6.22011C16.1602 6.08174 16.1476 5.92237 16.1935 5.775C16.2394 5.62763 16.3402 5.50355 16.475 5.42846C17.8869 4.67684 19.4612 4.28198 21.0606 4.27832C23.9061 4.27832 25.9151 5.44713 25.9151 8.27392V16.0784C25.9151 16.2369 25.8522 16.3889 25.7401 16.5009C25.6281 16.6129 25.4761 16.6759 25.3176 16.6759H23.7567C23.6761 16.6794 23.5956 16.6666 23.5201 16.6381C23.4445 16.6097 23.3755 16.5663 23.3173 16.5104C23.259 16.4546 23.2126 16.3875 23.181 16.3133C23.1493 16.239 23.1331 16.1591 23.1331 16.0784ZM22.9726 10.6825C22.4236 11.097 21.4117 11.2352 20.3325 11.4293C19.2533 11.6235 18.3571 11.911 18.3571 13.0836C18.3571 14.1628 19.1375 14.6669 20.2653 14.6669C21.6656 14.6669 22.9726 13.8864 22.9726 12.0716V10.6825Z"
      fill={color}
    />
    <path
      d="M28.4807 13.5844C28.5814 13.4671 28.7236 13.3934 28.8775 13.3788C29.0314 13.3642 29.185 13.4098 29.306 13.506C30.3043 14.26 31.528 14.6547 32.7788 14.6263C34.0671 14.6263 35.0193 14.2118 35.0193 13.2035C35.0193 12.2849 34.1455 12.1019 32.032 11.7323C29.7914 11.3588 27.648 10.612 27.648 8.0578C27.648 5.39531 29.9445 4.27131 32.5622 4.27131C34.2037 4.24705 35.8062 4.77287 37.1142 5.76499C37.178 5.81499 37.231 5.87744 37.2699 5.94856C37.3088 6.01967 37.3328 6.09796 37.3405 6.17865C37.3482 6.25935 37.3394 6.34077 37.3146 6.41795C37.2898 6.49513 37.2496 6.56646 37.1964 6.6276L36.4495 7.50514C36.3505 7.62282 36.2102 7.69809 36.0574 7.71545C35.9045 7.73282 35.7509 7.69096 35.628 7.59849C34.7077 6.92543 33.594 6.56902 32.4539 6.58279C31.3523 6.58279 30.3889 6.90393 30.3889 7.774C30.3889 8.74116 31.7407 8.92414 33.0962 9.15566C35.9902 9.65978 37.8274 10.485 37.8274 12.8899C37.8274 15.4142 35.8072 16.9751 32.5995 16.9751C30.8464 17.0287 29.1295 16.4687 27.7451 15.3918C27.683 15.3409 27.6316 15.2782 27.594 15.2073C27.5564 15.1364 27.5332 15.0587 27.5259 14.9788C27.5186 14.8988 27.5273 14.8183 27.5515 14.7417C27.5756 14.6652 27.6148 14.5942 27.6667 14.5329L28.4807 13.5844Z"
      fill={color}
    />
    <path
      d="M39.5997 16.0779V0.879703C39.5997 0.721243 39.6626 0.569276 39.7747 0.457228C39.8867 0.34518 40.0387 0.282227 40.1971 0.282227H41.9186C42.0771 0.282227 42.229 0.34518 42.3411 0.457228C42.4531 0.569276 42.5161 0.721243 42.5161 0.879703V6.07025C42.9447 5.49832 43.5039 5.03721 44.147 4.7254C44.7901 4.41359 45.4984 4.26013 46.2129 4.27784C48.7597 4.27784 50.2534 6.09266 50.2534 8.6842V16.0779C50.2534 16.2364 50.1904 16.3884 50.0784 16.5004C49.9663 16.6125 49.8143 16.6754 49.6559 16.6754H47.9344C47.776 16.6754 47.624 16.6125 47.5119 16.5004C47.3999 16.3884 47.3369 16.2364 47.3369 16.0779V9.35636C47.3369 8.06806 46.9224 6.89925 45.2719 6.89925C43.7073 6.89925 42.5161 8.00084 42.5161 9.83808V16.0817C42.5161 16.2401 42.4531 16.3921 42.3411 16.5042C42.229 16.6162 42.0771 16.6791 41.9186 16.6791H40.1971C40.1182 16.6796 40.04 16.6644 39.967 16.6343C39.8941 16.6042 39.8278 16.5599 39.7722 16.5039C39.7166 16.448 39.6727 16.3815 39.643 16.3083C39.6134 16.2352 39.5987 16.1568 39.5997 16.0779Z"
      fill={color}
    />
    <path
      d="M69.1994 16.2738L67.9596 12.6143H61.6936L60.4501 16.2738C60.4102 16.3916 60.3344 16.4939 60.2332 16.5663C60.132 16.6387 60.0107 16.6774 59.8863 16.6771H57.8661C57.77 16.677 57.6754 16.6536 57.5903 16.6091C57.5051 16.5646 57.432 16.5003 57.377 16.4215C57.322 16.3427 57.2869 16.2518 57.2745 16.1566C57.2621 16.0613 57.2729 15.9645 57.3059 15.8742L62.9483 0.672282C62.9933 0.560958 63.0709 0.465784 63.1708 0.399173C63.2707 0.332562 63.3884 0.297606 63.5085 0.298861H66.268C66.3907 0.299346 66.5103 0.337102 66.611 0.407128C66.7117 0.477153 66.7888 0.57614 66.8319 0.690954L72.4519 15.8892C72.485 15.9797 72.4958 16.0769 72.4832 16.1724C72.4706 16.268 72.4351 16.3591 72.3798 16.438C72.3244 16.5168 72.2507 16.5811 72.1651 16.6254C72.0795 16.6696 71.9844 16.6925 71.888 16.692H69.7558C69.631 16.6892 69.5102 16.6473 69.4104 16.5723C69.3106 16.4973 69.2368 16.3929 69.1994 16.2738ZM64.8602 2.94641L62.4479 10.0638H67.1792L64.8602 2.94641Z"
      fill={color}
    />
    <path
      d="M76.7777 5.15181V6.09283C77.202 5.50555 77.765 5.03246 78.4166 4.71578C79.0682 4.39911 79.7881 4.24871 80.512 4.278C83.8167 4.278 85.9527 7.01144 85.9527 10.5925C85.9527 14.1737 83.8167 16.9407 80.512 16.9407C79.786 16.9682 79.0646 16.8146 78.4127 16.4939C77.7609 16.1732 77.199 15.6954 76.7777 15.1035V20.0588C76.7777 20.2172 76.7148 20.3692 76.6027 20.4813C76.4907 20.5933 76.3387 20.6563 76.1803 20.6563H74.4588C74.3003 20.6563 74.1484 20.5933 74.0363 20.4813C73.9243 20.3692 73.8613 20.2172 73.8613 20.0588V5.12193C73.8613 4.96347 73.9243 4.8115 74.0363 4.69945C74.1484 4.5874 74.3003 4.52446 74.4588 4.52446H76.1803C76.2613 4.52436 76.3415 4.54075 76.416 4.57262C76.4905 4.6045 76.5578 4.6512 76.6137 4.70988C76.6696 4.76856 76.7129 4.83801 76.7411 4.91398C76.7693 4.98995 76.7818 5.07087 76.7777 5.15181ZM79.8995 14.4052C81.9197 14.4052 82.8869 12.68 82.8869 10.5925C82.8869 8.50513 81.9011 6.82473 79.8995 6.82473C77.898 6.82473 76.7777 8.50139 76.7777 10.5925C76.7777 12.6837 77.842 14.4052 79.8995 14.4052Z"
      fill={color}
    />
    <path
      d="M90.6703 5.15165V6.09268C91.095 5.50589 91.6582 5.03316 92.3096 4.71653C92.9611 4.39991 93.6808 4.24922 94.4045 4.27785C97.713 4.27785 99.849 7.01129 99.849 10.5924C99.849 14.1735 97.713 16.9405 94.4045 16.9405C93.6787 16.9673 92.9575 16.8135 92.3057 16.4928C91.654 16.1722 91.092 15.6947 90.6703 15.1033V20.0586C90.6703 20.2171 90.6074 20.369 90.4953 20.4811C90.3833 20.5931 90.2313 20.6561 90.0729 20.6561H88.3514C88.1929 20.6561 88.0409 20.5931 87.9289 20.4811C87.8169 20.369 87.7539 20.2171 87.7539 20.0586V5.12178C87.7539 4.96332 87.8169 4.81135 87.9289 4.6993C88.0409 4.58725 88.1929 4.5243 88.3514 4.5243H90.0729C90.1541 4.52366 90.2345 4.53968 90.3093 4.57137C90.384 4.60306 90.4515 4.64975 90.5075 4.70855C90.5635 4.76735 90.6068 4.83701 90.6348 4.91322C90.6628 4.98944 90.6749 5.07059 90.6703 5.15165ZM93.7959 14.405C95.8161 14.405 96.7832 12.6798 96.7832 10.5924C96.7832 8.50497 95.7974 6.82458 93.7959 6.82458C91.7943 6.82458 90.6703 8.50124 90.6703 10.5924C90.6703 12.6836 91.7495 14.405 93.7959 14.405Z"
      fill={color}
    />
    <path
      d="M112.773 3.0485H117.26C117.69 3.0485 117.939 2.79924 117.939 2.3687V0.986442C117.939 0.555902 117.69 0.306641 117.26 0.306641H105.295C104.864 0.306641 104.615 0.555902 104.615 0.986442V2.3687C104.615 2.79924 104.864 3.0485 105.295 3.0485H109.782V15.8061C109.782 16.2366 110.031 16.4859 110.462 16.4859H112.093C112.524 16.4859 112.773 16.2366 112.773 15.8061V3.0485Z"
      fill={color}
    />
    <path
      d="M125.886 16.4859H127.245C127.676 16.4859 127.925 16.2366 127.925 15.8061V8.19232C127.925 5.40514 125.954 4.24948 123.144 4.24948C121.512 4.24948 119.926 4.68002 118.702 5.33716C118.317 5.5411 118.249 5.881 118.43 6.26622L118.861 7.14996C119.065 7.55784 119.382 7.62582 119.79 7.42188C120.787 6.92336 121.965 6.65144 122.917 6.65144C123.891 6.65144 125.047 6.92336 125.047 7.9204C125.047 9.0534 123.574 9.1667 121.852 9.41596C120.243 9.64256 117.637 10.1411 117.637 13.0642C117.637 15.4209 119.337 16.7578 121.784 16.7578C123.438 16.7578 124.481 16.1686 125.206 15.2169V15.8514C125.206 16.2593 125.455 16.4859 125.886 16.4859ZM125.047 10.5716V11.9312C125.047 13.7214 123.756 14.4918 122.373 14.4918C121.263 14.4918 120.492 13.9933 120.492 12.9283C120.492 11.7726 121.399 11.5007 122.441 11.2967C123.506 11.1155 124.503 10.9795 125.047 10.5716Z"
      fill={color}
    />
    <path
      d="M138.256 16.4859H140.182C140.726 16.4859 140.953 16.146 140.635 15.6701L136.965 10.2317L140.273 5.33716C140.59 4.8613 140.386 4.5214 139.842 4.5214H138.007C137.644 4.5214 137.372 4.65736 137.191 4.9746L135.129 8.4869L132.976 4.9746C132.795 4.65736 132.523 4.5214 132.161 4.5214H130.302C129.759 4.5214 129.555 4.8613 129.872 5.33716L133.18 10.2317L129.509 15.6701C129.192 16.146 129.396 16.4859 129.94 16.4859H131.866C132.229 16.4859 132.5 16.3499 132.682 16.0327L135.061 12.1125L137.44 16.0327C137.622 16.3499 137.894 16.4859 138.256 16.4859Z"
      fill={color}
    />
    <path
      d="M141.695 10.549C141.695 14.1066 143.894 16.7578 147.791 16.7578C149.672 16.7578 151.235 16.146 152.436 14.9677C152.754 14.6504 152.708 14.3332 152.391 14.0159L151.553 13.2002C151.235 12.8829 150.918 12.9283 150.601 13.2228C149.876 13.8573 148.969 14.1972 147.95 14.1972C146.16 14.1972 144.8 13.1549 144.777 11.1834H152.572C153.003 11.1834 153.252 10.9568 153.275 10.5263C153.297 10.413 153.297 10.277 153.297 10.1184C153.297 6.71942 151.167 4.24948 147.61 4.24948C143.871 4.24948 141.695 6.99134 141.695 10.549ZM150.442 9.1667H144.8C144.936 7.55784 146.024 6.47016 147.655 6.47016C149.128 6.47016 150.306 7.3539 150.442 9.1667Z"
      fill={color}
    />
    <path
      d="M155.159 13.4948L154.502 14.2652C154.23 14.6051 154.23 14.945 154.57 15.2396C155.771 16.214 157.403 16.7578 159.306 16.7578C162.456 16.7578 164.45 15.2169 164.45 12.7243C164.45 10.3677 162.637 9.55192 159.782 9.0534C158.445 8.8268 157.108 8.64552 157.108 7.6938C157.108 6.83272 158.06 6.51548 159.148 6.51548C160.326 6.51548 161.414 6.9007 162.184 7.44454C162.524 7.71646 162.864 7.71646 163.136 7.37656L163.77 6.62878C164.065 6.28888 164.065 5.94898 163.702 5.67706C162.683 4.90662 161.187 4.24948 159.261 4.24948C156.678 4.24948 154.412 5.35982 154.412 7.98838C154.412 10.5036 156.542 11.2288 158.74 11.614C160.824 11.9765 161.686 12.1578 161.686 13.0642C161.686 14.0613 160.734 14.4691 159.465 14.4691C158.332 14.4691 157.108 14.1746 156.134 13.4268C155.771 13.1549 155.431 13.1549 155.159 13.4948Z"
      fill={color}
    />
  </svg>
)

const Taxes = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.0001 6C8.79054 6 6.06968 7.92898 5.12685 10.5981C5.08191 10.7253 5.05944 10.7889 5.07308 10.8463C5.08458 10.8946 5.11744 10.9411 5.1592 10.968C5.20872 11 5.27961 11 5.4214 11L18.5786 10.9996C18.7204 10.9996 18.7913 10.9996 18.8408 10.9676C18.8826 10.9407 18.9154 10.8942 18.9269 10.8459C18.9405 10.7885 18.9181 10.7249 18.8731 10.5977C17.9302 7.92879 15.2094 6 12.0001 6Z"
      fill="currentColor"
    />
    <path d="M4 14L20 14" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M6 14L6 21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M10 14L10 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M14 14L14 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    <path d="M18 14L18 21" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M4 21H20" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M12 9L12 2" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    <rect x="11" y="2" width="5" height="3" rx="0.5" fill="currentColor" />
  </svg>
)

const LightningCircle = ({ color = '#00D64F', width, height, ...props }: React.SVGAttributes<SVGElement>) => (
  <svg {...props} width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="56" height="56" rx="28" fill={color} />
    <path
      d="m28.75 31 4.547-16.89c.198-.734-.697-1.262-1.244-.735L16.43 28.42c-.973.937-.31 2.581 1.04 2.581h11.28Z"
      fill="#fff"
    />
    <path
      d="m27.25 25-4.547 16.89c-.198.734.697 1.262 1.244.735L39.57 27.58c.973-.937.31-2.581-1.04-2.581H27.25Z"
      fill="#fff"
    />
  </svg>
)
const Lightning = ({
  width = '1.5em',
  height = '1.5em',
  color = '#018206',
  ...props
}: React.SVGAttributes<SVGElement>) => (
  <svg
    {...props}
    width={width}
    height={height}
    color={color}
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="m12.5 14 3.031-11.26c.132-.49-.464-.842-.83-.49L4.287 12.28c-.648.624-.206 1.72.694 1.72h7.52Z"
      fill="currentColor"
    />
    <path
      d="M11.5 10 8.469 21.26c-.132.49.464.841.83.49l10.415-10.03c.648-.624.206-1.72-.694-1.72H11.5Z"
      fill="currentColor"
    />
  </svg>
)

const PriceTag = (props: React.SVGAttributes<SVGElement>) => (
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.38855 0.811875C10.0577 0.142676 11.0221 -0.138828 11.9462 0.0652813L16.7623 1.129C17.8157 1.36165 18.6383 2.18435 18.871 3.23772L19.9347 8.05375C20.1388 8.97787 19.8573 9.94225 19.1881 10.6115L10.6114 19.1882C9.52897 20.2706 7.774 20.2706 6.69157 19.1882L0.811824 13.3084C-0.270608 12.226 -0.270608 10.471 0.811824 9.3886L9.38855 0.811875ZM16.1645 3.8355L11.3485 2.77179L2.77174 11.3485L8.65149 17.2283L17.2282 8.65154L16.1645 3.8355Z"
      fill="currentColor"
    />
    <path
      d="M14.2046 7.75534C13.6634 8.29656 12.7859 8.29656 12.2447 7.75534C11.7034 7.21413 11.7034 6.33664 12.2447 5.79543C12.7859 5.25421 13.6634 5.25421 14.2046 5.79543C14.7458 6.33664 14.7458 7.21413 14.2046 7.75534Z"
      fill="currentColor"
    />
  </svg>
)

const Numeral1 = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0a8 8 0 0 0-8 8v8a8 8 0 0 0 8 8h8a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8Zm1.244 10.03-.48-.735c-.15-.24-.105-.465.135-.63l2.49-1.695a.85.85 0 0 1 .555-.18h.96c.285 0 .45.165.45.45v9.81c0 .285-.165.45-.45.45h-1.08c-.285 0-.45-.165-.45-.45V9.115l-1.5 1.035c-.24.165-.465.135-.63-.12Z"
      fill="currentColor"
    />
  </svg>
)

const Numeral2 = (props: React.SVGAttributes<SVGElement>) => {
  const def = useUniqueDef()
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath={def.url}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 0a8 8 0 0 0-8 8v8a8 8 0 0 0 8 8h8.075a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8Zm7.287 17.5H8.665c-.286 0-.452-.09-.452-.255 0-1.485 1.084-2.76 3.07-4.515l.292-.253c1.138-.983 1.92-1.658 1.92-2.627 0-.975-.753-1.485-1.685-1.485-.798 0-1.505.375-1.956 1.05-.166.24-.362.315-.617.165l-.798-.465c-.256-.15-.316-.36-.15-.615.752-1.125 1.986-1.905 3.671-1.905 2.152 0 3.656 1.26 3.656 3.255 0 1.395-.722 2.265-1.76 3.12-.377.32-.8.64-1.218.956-.817.617-1.614 1.218-2.002 1.774h4.65c.285 0 .45.165.45.45v.9c0 .285-.165.45-.45.45Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id={def.id}>
          <path fill="#fff" d="M0 0h24.075v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

const Numeral3 = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 0a8 8 0 0 0-8 8v8a8 8 0 0 0 8 8h8a8 8 0 0 0 8-8V8a8 8 0 0 0-8-8H8Zm2.979 12.265-.24-.24c-.195-.195-.21-.405-.045-.63l2.175-2.79H8.924c-.285 0-.45-.165-.45-.45V7.24c0-.285.165-.45.45-.45h5.97c.285 0 .45.165.45.45v.495a.81.81 0 0 1-.195.555l-1.98 2.535c1.515.21 2.64 1.395 2.64 3.15 0 1.89-1.305 3.72-4.05 3.72-1.725 0-2.82-.735-3.555-1.86-.15-.255-.075-.465.165-.615l.765-.465c.24-.15.45-.09.615.165.45.615 1.11 1.02 1.965 1.02 1.185 0 2.07-.75 2.07-1.95 0-1.02-.66-1.74-1.62-1.74-.21 0-.39.045-.555.105-.255.09-.435.105-.63-.09Z"
      fill="currentColor"
    />
  </svg>
)

const Bag = ({ color = '#BFBFBF', ...props }: React.SVGAttributes<SVGElement>) => {
  const def1 = useUniqueDef()
  const def2 = useUniqueDef()
  return (
    <svg width="1em" height="1em" viewBox="0 0 16 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.5C0 5.67157 0.671573 5 1.5 5H14.5C15.3284 5 16 5.67157 16 6.5V17.5C16 18.3284 15.3284 19 14.5 19H1.5C0.671573 19 0 18.3284 0 17.5V6.5ZM4 9C4 8.44772 4.44772 8 5 8C5.55228 8 6 8.44772 6 9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9ZM11 8C10.4477 8 10 8.44772 10 9C10 9.55228 10.4477 10 11 10C11.5523 10 12 9.55228 12 9C12 8.44772 11.5523 8 11 8Z"
        fill={color}
      />
      <rect x="4" y="4" width="1.5" height="3" fill={color} />
      <rect x="10.5" y="4" width="1.5" height="3" fill={color} />
      <mask id={def1.id} style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="4">
        <rect width="16" height="4" fill={color} />
      </mask>
      <g mask={def1.url}>
        <mask id={def2.id} fill={color}>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 6.5C9.38071 6.5 10.5 5.38071 10.5 4C10.5 2.61929 9.38071 1.5 8 1.5C6.61929 1.5 5.5 2.61929 5.5 4C5.5 5.38071 6.61929 6.5 8 6.5ZM12 4C12 6.20914 10.2091 8 8 8C5.79086 8 4 6.20914 4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 6.5C9.38071 6.5 10.5 5.38071 10.5 4C10.5 2.61929 9.38071 1.5 8 1.5C6.61929 1.5 5.5 2.61929 5.5 4C5.5 5.38071 6.61929 6.5 8 6.5ZM12 4C12 6.20914 10.2091 8 8 8C5.79086 8 4 6.20914 4 4C4 1.79086 5.79086 0 8 0C10.2091 0 12 1.79086 12 4Z"
          fill={color}
        />
        <path
          d="M9 4C9 4.55228 8.55228 5 8 5V8C10.2091 8 12 6.20914 12 4H9ZM8 3C8.55228 3 9 3.44772 9 4H12C12 1.79086 10.2091 0 8 0V3ZM7 4C7 3.44772 7.44772 3 8 3V0C5.79086 0 4 1.79086 4 4H7ZM8 5C7.44772 5 7 4.55228 7 4H4C4 6.20914 5.79086 8 8 8V5ZM8 9.5C11.0376 9.5 13.5 7.03757 13.5 4H10.5C10.5 5.38071 9.38071 6.5 8 6.5V9.5ZM2.5 4C2.5 7.03757 4.96243 9.5 8 9.5V6.5C6.61929 6.5 5.5 5.38071 5.5 4H2.5ZM8 -1.5C4.96243 -1.5 2.5 0.962434 2.5 4H5.5C5.5 2.61929 6.61929 1.5 8 1.5V-1.5ZM13.5 4C13.5 0.962434 11.0376 -1.5 8 -1.5V1.5C9.38071 1.5 10.5 2.61929 10.5 4H13.5Z"
          fill={color}
          mask={def2.url}
        />
      </g>
    </svg>
  )
}

const AppSwitch = ({ color = '#00D64F', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="11" y="3" width="23" height="40" rx="5" fill="#464646" />
    <rect x="22" y="13" width="23" height="40" rx="5" fill={color} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M34.113 28.7732C35.3386 28.7732 36.5132 29.2695 37.2807 29.9507C37.4748 30.123 37.7654 30.122 37.9475 29.9374L38.8607 29.0112C39.0534 28.8157 39.0464 28.4956 38.8383 28.317C38.2255 27.7902 37.4029 27.2722 36.3904 26.9406L36.6767 25.5767C36.7389 25.2795 36.5125 25.0001 36.2086 25.0001H34.444C34.2183 25.0001 34.0232 25.1581 33.9761 25.3788L33.7182 26.5917C31.3724 26.7089 29.3843 27.8794 29.3843 30.2809C29.3843 32.36 31.0292 33.2511 32.7654 33.8677C34.4103 34.4843 35.2782 34.7131 35.2782 35.5811C35.2782 36.4721 34.4103 36.9975 33.1307 36.9975C31.9641 36.9975 30.7421 36.6125 29.7938 35.6776C29.6078 35.494 29.3102 35.4926 29.1242 35.6762L28.1429 36.6441C27.951 36.8333 27.9527 37.1442 28.1461 37.3316C28.9112 38.0742 29.8798 38.6119 30.9853 38.913L30.7161 40.1765C30.6533 40.4727 30.8776 40.752 31.1808 40.7545L32.9482 40.7678C33.1756 40.7696 33.3732 40.6106 33.4195 40.3877L33.6747 39.1731C36.4834 38.9997 38.2023 37.4731 38.2023 35.2385C38.2023 33.1826 36.4893 32.3144 34.4103 31.6061C33.2223 31.1717 32.194 30.8751 32.194 29.9844C32.194 29.1165 33.1539 28.7732 34.113 28.7732Z"
      fill="white"
    />
  </svg>
)

const Calendar = ({ color = '#00D64F', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="56" height="56" rx="28" fill={color} />
    <rect x="14.6641" y="14.6665" width="26.6667" height="26.6667" rx="5" stroke="white" strokeWidth="5" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.991 16.3045C14.6641 16.9463 14.6641 17.7863 14.6641 19.4665V23H41.3307V19.4665C41.3307 17.7863 41.3307 16.9463 41.0037 16.3045C40.7161 15.74 40.2572 15.2811 39.6927 14.9935C39.051 14.6665 38.2109 14.6665 36.5307 14.6665H19.4641C17.7839 14.6665 16.9438 14.6665 16.3021 14.9935C15.7376 15.2811 15.2787 15.74 14.991 16.3045Z"
      fill="white"
    />
    <circle cx="24" cy="32" r="4" fill="white" />
  </svg>
)

const CalendarSquare = ({ color = '#333', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="4" y="4" width="16" height="16" rx="3" stroke={color} strokeWidth="3" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.327 5.638C4 6.28 4 7.12 4 8.8V9h16v6.378V8.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C17.72 4 16.88 4 15.2 4H8.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311Z"
      fill={color}
    />
    <circle cx="9" cy="15" r="2" fill={color} />
  </svg>
)

const Card = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect x="1.5" y="1.5" width="21" height="17" rx="4.5" stroke="currentColor" strokeWidth="3" />
    <rect
      x="7"
      y="7"
      width="3"
      height="2"
      rx="1"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Desktop = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <rect
      x="2"
      y="3"
      width="20"
      height="13"
      rx="1"
      stroke={props.fill || 'currentColor'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 17V20"
      stroke={props.fill || 'currentColor'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 21H16"
      stroke={props.fill || 'currentColor'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const DesktopCircle = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="56" height="56" rx="28" fill={props.fill || 'currentColor'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.625 19C13.625 17.2741 15.0241 15.875 16.75 15.875H39.25C40.9759 15.875 42.375 17.2741 42.375 19V32.75C42.375 34.4759 40.9759 35.875 39.25 35.875H16.75C15.0241 35.875 13.625 34.4759 13.625 32.75V19ZM17.375 19.625V32.125H38.625V19.625H17.375Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M28 33.375C29.0355 33.375 29.875 34.2145 29.875 35.25V39C29.875 40.0355 29.0355 40.875 28 40.875C26.9645 40.875 26.125 40.0355 26.125 39V35.25C26.125 34.2145 26.9645 33.375 28 33.375Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.125 40.25C21.125 39.2145 21.9645 38.375 23 38.375H33C34.0355 38.375 34.875 39.2145 34.875 40.25C34.875 41.2855 34.0355 42.125 33 42.125H23C21.9645 42.125 21.125 41.2855 21.125 40.25Z"
      fill="white"
    />
  </svg>
)

const Fdic = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4228 0.990612C12.5172 0.587764 11.4833 0.587765 10.5777 0.990612L3.53563 4.12323C2.32677 4.66099 1.47405 5.86774 1.50936 7.2792C1.5359 8.34045 1.63164 9.94776 1.93903 11.6521C2.24287 13.3367 2.77244 15.2272 3.72808 16.7842C5.47073 19.6233 8.78477 21.8307 10.3115 22.7575C11.3533 23.3901 12.6473 23.3899 13.689 22.7574C15.2157 21.8303 18.5302 19.6225 20.2723 16.7842C21.2279 15.2272 21.7575 13.3367 22.0613 11.6521C22.3688 9.9478 22.4645 8.3405 22.4911 7.27925C22.5264 5.86777 21.6737 4.66098 20.4648 4.12322L13.4228 0.990612ZM11.797 3.73164C11.9264 3.67409 12.0741 3.67409 12.2035 3.73164L19.2455 6.86424C19.4288 6.94581 19.4948 7.09237 19.492 7.20419C19.4678 8.17372 19.38 9.61691 19.109 11.1196C18.8344 12.642 18.3906 14.115 17.7155 15.2149C16.3838 17.3844 13.639 19.278 12.1319 20.1931C12.0468 20.2448 11.9534 20.2448 11.8683 20.1931C10.3615 19.2783 7.61706 17.3853 6.28487 15.2149C5.6098 14.115 5.16597 12.642 4.89139 11.1196C4.62037 9.61691 4.53267 8.17372 4.50842 7.20419C4.50562 7.09237 4.57161 6.94582 4.75497 6.86425L11.797 3.73164ZM17.3411 8.42722L12.3537 6.16018C12.1881 6.08494 12.0002 6.20595 12.0002 6.38777V17.0697C12.0002 17.2614 12.2096 17.3879 12.3754 17.2916C13.1844 16.8219 15.0929 15.5945 16.0002 13.9995C17.0793 12.1025 17.4135 9.37766 17.4844 8.67171C17.4949 8.5673 17.4367 8.47064 17.3411 8.42722Z"
      fill="currentColor"
    />
  </svg>
)

const EyeClosed = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props} fill="none" stroke="none">
    <path
      d="m15.014 10.219-4.795 4.795a3.5 3.5 0 1 1 4.795-4.795ZM18.66 10.107A17.42 17.42 0 0 1 20.097 12c-.606.924-1.578 2.211-2.86 3.314C15.74 16.6 13.989 17.5 12 17.5c-.235 0-.467-.013-.695-.037l-2.1 2.1c.87.276 1.802.437 2.795.437 5.57 0 9.24-5.065 10.508-7.135a1.641 1.641 0 0 0 0-1.73 19.882 19.882 0 0 0-2.076-2.8l-1.771 1.772Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M8.623 16.609a10.432 10.432 0 0 1-1.86-1.295C5.483 14.21 4.51 12.924 3.903 12c.607-.924 1.58-2.211 2.86-3.314C8.26 7.4 10.013 6.5 12 6.5c1.822 0 3.447.756 4.858 1.874l1.778-1.778C16.896 5.16 14.666 4 12 4 6.43 4 2.76 9.065 1.492 11.135a1.641 1.641 0 0 0 0 1.73c.816 1.333 2.629 3.908 5.303 5.572l1.828-1.828Z"
      fill={props.fill || 'currentColor'}
    />
    <path d="M20 4 4 20" stroke={props.stroke || 'currentColor'} strokeWidth="2.5" strokeLinecap="round" />
  </svg>
)

const EyeOpen = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props} fill="none" stroke="none">
    <path
      d="M21.442 11.788a.392.392 0 0 1 0 .424c-.598.977-1.753 2.641-3.39 4.05-1.634 1.405-3.666 2.488-6.052 2.488-2.386 0-4.418-1.082-6.052-2.489-1.637-1.408-2.792-3.072-3.39-4.049l-1.066.653 1.066-.653a.392.392 0 0 1 0-.424c.598-.977 1.753-2.641 3.39-4.05C7.582 6.333 9.614 5.25 12 5.25c2.386 0 4.418 1.082 6.052 2.489 1.637 1.408 2.792 3.072 3.39 4.049Z"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2.5"
    />
    <circle cx="12" cy="12" r="3.5" fill={props.fill || 'currentColor'} />
  </svg>
)

const Link = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.9817 14.5035L20.1317 12.3535C22.4748 10.0103 22.4748 6.21134 20.1317 3.8682C17.7885 1.52505 13.9895 1.52505 11.6464 3.8682L9.3483 6.1663C7.00516 8.50944 7.00516 12.3084 9.3483 14.6516C9.93409 15.2374 10.8838 15.2374 11.4696 14.6516C12.0554 14.0658 12.0554 13.116 11.4696 12.5303C10.298 11.3587 10.298 9.45919 11.4696 8.28762L13.7677 5.98952C14.9393 4.81795 16.8388 4.81795 18.0104 5.98952C19.1819 7.16109 19.1819 9.06059 18.0104 10.2322L17.423 10.8195C17.9242 12.0074 18.1121 13.2793 17.9817 14.5035ZM6.0183 9.49641L3.86832 11.6464C1.52518 13.9895 1.52518 17.7885 3.86832 20.1317C6.21147 22.4748 10.0105 22.4748 12.3536 20.1317L14.6517 17.8336C16.9948 15.4904 16.9948 11.6914 14.6517 9.34828C14.0659 8.7625 13.1162 8.7625 12.5304 9.34828C11.9446 9.93407 11.9446 10.8838 12.5304 11.4696C13.702 12.6412 13.702 14.5407 12.5304 15.7122L10.2323 18.0103C9.06071 19.1819 7.16121 19.1819 5.98964 18.0103C4.81807 16.8388 4.81807 14.9393 5.98964 13.7677L6.57699 13.1804C6.07575 11.9925 5.88794 10.7206 6.0183 9.49641Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

const LinkOut = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3412 2.5C13.5128 2.49999 12.8412 3.17156 12.8412 3.99999C12.8412 4.82842 13.5128 5.49999 14.3412 5.5L16.3768 5.50002L11.1593 10.7175C10.5735 11.3033 10.5735 12.2531 11.1593 12.8389C11.7451 13.4246 12.6948 13.4246 13.2806 12.8389L18.4981 7.62139L18.4981 9.65684C18.4981 10.4853 19.1696 11.1568 19.9981 11.1569C20.8265 11.1569 21.4981 10.4853 21.4981 9.65687L21.4981 4.00005C21.4981 3.60223 21.3401 3.2207 21.0588 2.93939C20.7775 2.65808 20.396 2.50005 19.9981 2.50004L14.3412 2.5ZM8 5.5L7.94445 5.5C7.29194 5.49997 6.71445 5.49994 6.23586 5.53904C5.72622 5.58068 5.19813 5.67403 4.68404 5.93597C3.93139 6.31947 3.31947 6.93139 2.93598 7.68404C2.67404 8.19813 2.58069 8.72622 2.53905 9.23586C2.49995 9.71443 2.49997 10.2919 2.5 10.9444V10.9444L2.50001 11V16L2.5 16.0556V16.0556C2.49997 16.7081 2.49995 17.2856 2.53905 17.7641C2.58069 18.2738 2.67404 18.8019 2.93598 19.316C3.31947 20.0686 3.93139 20.6805 4.68404 21.064C5.19813 21.326 5.72622 21.4193 6.23586 21.461C6.71446 21.5001 7.29194 21.5 7.94446 21.5L8 21.5H13L13.0556 21.5C13.7081 21.5 14.2856 21.5001 14.7641 21.461C15.2738 21.4193 15.8019 21.326 16.316 21.064C17.0686 20.6805 17.6805 20.0686 18.064 19.316C18.326 18.8019 18.4193 18.2738 18.461 17.7641C18.5001 17.2855 18.5 16.7081 18.5 16.0555L18.5 16V15C18.5 14.1716 17.8284 13.5 17 13.5C16.1716 13.5 15.5 14.1716 15.5 15V16C15.5 16.7248 15.4988 17.1782 15.4709 17.5198C15.4444 17.844 15.4016 17.9333 15.391 17.954C15.2951 18.1422 15.1422 18.2951 14.954 18.391C14.9333 18.4015 14.844 18.4444 14.5199 18.4709C14.1782 18.4988 13.7248 18.5 13 18.5H8C7.27519 18.5 6.82179 18.4988 6.48016 18.4709C6.15604 18.4444 6.0667 18.4015 6.04601 18.391C5.85785 18.2951 5.70487 18.1422 5.609 17.954C5.59846 17.9333 5.55557 17.844 5.52908 17.5198C5.50117 17.1782 5.50001 16.7248 5.50001 16V11C5.50001 10.2752 5.50117 9.82178 5.52908 9.48015C5.55557 9.15603 5.59846 9.0667 5.609 9.04601C5.70487 8.85785 5.85785 8.70487 6.04601 8.60899C6.0667 8.59845 6.15604 8.55556 6.48016 8.52908C6.82179 8.50117 7.27519 8.5 8 8.5H9C9.82843 8.5 10.5 7.82843 10.5 7C10.5 6.17157 9.82843 5.5 9 5.5H8Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

const Phone = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" {...props} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.9994 14.9738V17.9846C20.0017 18.5498 19.7651 19.0898 19.3478 19.4718C18.9305 19.8539 18.3712 20.0427 17.8072 19.9918C14.7128 19.6563 11.7404 18.601 9.1289 16.9108C6.69922 15.3699 4.63927 13.3141 3.09534 10.8892C1.39587 8.27099 0.338248 5.29008 0.00816924 2.18795C-0.0426402 1.62681 0.145204 1.07019 0.525814 0.654067C0.906425 0.237942 1.44475 0.000629267 2.0093 9.86731e-05H5.02608C6.03556 -0.00981707 6.89598 0.728681 7.03727 1.72629C7.1646 2.68982 7.40074 3.63587 7.74118 4.54641C8.01746 5.27992 7.84075 6.10682 7.28867 6.66401L6.01156 7.93859C7.44308 10.4512 9.52758 12.5315 12.0451 13.9602L13.3222 12.6856C13.8805 12.1346 14.7091 11.9583 15.444 12.234C16.3564 12.5738 17.3043 12.8094 18.2698 12.9365C19.2809 13.0789 20.0247 13.955 19.9994 14.9738Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

const Chat = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
    stroke="none"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.9975 15.1398C15.1011 15.1277 15.7739 15.0777 16.3429 14.8708C17.756 14.3568 18.8656 13.168 19.3453 11.654C19.6 10.8499 19.6 9.85261 19.6 7.85798C19.6 5.86335 19.6 4.86603 19.3453 4.06201C18.8656 2.548 17.756 1.35913 16.3429 0.845196C15.5925 0.572266 14.6617 0.572266 12.8 0.572266H7.2C5.33835 0.572266 4.40752 0.572266 3.65709 0.845196C2.24402 1.35913 1.13441 2.548 0.654737 4.06201C0.400002 4.86603 0.400002 5.86335 0.400002 7.85798C0.400002 9.85261 0.400002 10.8499 0.654737 11.654C1.13441 13.168 2.24402 14.3568 3.65709 14.8708C4.31157 15.1088 5.10328 15.1392 6.53002 15.1431L12.7649 19.4376C13.2973 19.8043 13.9975 19.3947 13.9975 18.7166V15.1398ZM12.8 3.14369H7.2C5.14336 3.14369 4.70918 3.17809 4.42855 3.28016C3.72201 3.53713 3.16721 4.13156 2.92737 4.88856C2.83211 5.18924 2.8 5.65444 2.8 7.85798C2.8 10.0615 2.83211 10.5267 2.92737 10.8274C3.16721 11.5844 3.72201 12.1788 4.42855 12.4358C4.70918 12.5379 5.14336 12.5723 7.2 12.5723H6.94153C7.09302 12.5723 7.24139 12.6183 7.36939 12.7052L11.216 15.3138L11.5975 15.5766L11.5972 13.0008C11.5972 12.7641 11.7763 12.5723 11.9972 12.5723H12.8C14.8566 12.5723 15.2908 12.5379 15.5715 12.4358C16.278 12.1788 16.8328 11.5844 17.0726 10.8274C17.1679 10.5267 17.2 10.0615 17.2 7.85798C17.2 5.65444 17.1679 5.18924 17.0726 4.88856C16.8328 4.13156 16.278 3.53713 15.5715 3.28016C15.2908 3.17809 14.8566 3.14369 12.8 3.14369Z"
      fill={props.fill || 'currentColor'}
    />
    <path
      d="M2.8 2.28655H18V13.4294H2.8V2.28655Z"
      fill={props.fill || 'currentColor'}
      stroke={props.fill || 'currentColor'}
    />
    <path d="M12.0098 12.7506L11.8 16.7234L8.35294 13.4454L12.0098 12.7506Z" fill={props.fill || 'currentColor'} />
  </svg>
)

const Search = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.0962 15.0962C17.6346 12.5578 17.6346 8.44221 15.0962 5.9038C12.5578 3.36539 8.44222 3.36539 5.90381 5.9038C3.3654 8.44221 3.3654 12.5578 5.90381 15.0962C8.44222 17.6346 12.5578 17.6346 15.0962 15.0962ZM15.0962 15.0962L20 20"
      stroke={props.fill || 'currentColor'}
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Plane = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.8304 4.99461C23.645 2.62474 21.376 0.3547 19.0054 1.1696L3.05147 6.65375C0.368019 7.57619 0.3346 11.3593 3.00132 12.329L9.35903 14.6409L11.6709 20.9987C12.641 23.6662 16.4241 23.6311 17.3462 20.9485L22.8304 4.99461ZM19.9933 4.01936L14.5092 19.9733C14.5061 19.9822 14.4936 19.9823 14.4903 19.9734L12.5 14.5L14.2834 10.0416C14.365 9.83753 14.1625 9.63501 13.9584 9.71664L9.5 11.5L4.02657 9.50966C4.01771 9.50644 4.01782 9.49387 4.02674 9.49081L19.9806 4.00666C19.9885 4.00395 19.9961 4.01149 19.9933 4.01936Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

const Transfer = ({ color = 'currentColor', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.56065 10.0607C2.97486 10.6465 2.02511 10.6464 1.43933 10.0607C0.85355 9.47486 0.853557 8.52511 1.43935 7.93933L5.43941 3.93933C5.72072 3.65803 6.10225 3.5 6.50007 3.5C6.8979 3.5 7.27943 3.65804 7.56073 3.93935L11.5607 7.93935C12.1465 8.52514 12.1464 9.47489 11.5607 10.0607C10.9749 10.6465 10.0251 10.6464 9.43933 10.0607L8.00006 8.62136V12L8.00006 16.0355L8.00006 17.4508V17.8554V17.963V17.9906V17.9976V17.9994V17.9999V18L6.50006 18L5.00006 18V17.9999V17.9994V17.9976V17.9906V17.963V17.8554V17.4508V16.0355V12V8.62128L3.56065 10.0607ZM6.50006 18H5.00006C5.00006 18.8284 5.67163 19.5 6.50006 19.5C7.32849 19.5 8.00006 18.8284 8.00006 18H6.50006ZM20.4393 13.9393C21.0251 13.3535 21.9749 13.3536 22.5607 13.9393C23.1465 14.5251 23.1464 15.4749 22.5607 16.0607L18.5606 20.0607C18.2793 20.342 17.8978 20.5 17.4999 20.5C17.1021 20.5 16.7206 20.342 16.4393 20.0607L12.4393 16.0607C11.8535 15.4749 11.8536 14.5251 12.4393 13.9393C13.0251 13.3535 13.9749 13.3536 14.5607 13.9393L15.9999 15.3786V12V11.9838V11.9676V11.9514V11.9352V11.919V11.9028V11.8865V11.8703V11.854V11.8377V11.8214V11.8051V11.7888V11.7725V11.7562V11.7399V11.7235V11.7072V11.6908V11.6745V11.6581V11.6417V11.6253V11.6089V11.5925V11.5761V11.5597V11.5433V11.5269V11.5105V11.494V11.4776V11.4611V11.4447V11.4282V11.4118V11.3953V11.3788V11.3623V11.3459V11.3294V11.3129V11.2964V11.2799V11.2634V11.2469V11.2304V11.2139V11.1973V11.1808V11.1643V11.1478V11.1313V11.1147V11.0982V11.0817V11.0651V11.0486V11.0321V11.0155V10.999V10.9825V10.9659V10.9494V10.9328V10.9163V10.8998V10.8832V10.8667V10.8502V10.8336V10.8171V10.8005V10.784V10.7675V10.7509V10.7344V10.7179V10.7014V10.6848V10.6683V10.6518V10.6353V10.6188V10.6023V10.5858V10.5692V10.5527V10.5363V10.5198V10.5033V10.4868V10.4703V10.4538V10.4374V10.4209V10.4044V10.388V10.3715V10.3551V10.3386V10.3222V10.3058V10.2894V10.2729V10.2565V10.2401V10.2237V10.2074V10.191V10.1746V10.1582V10.1419V10.1255V10.1092V10.0929V10.0765V10.0602V10.0439V10.0276V10.0113V9.99504V9.97876V9.9625V9.94625V9.93001V9.91377V9.89755V9.88134V9.86514V9.84894V9.83276V9.8166V9.80044V9.78429V9.76816V9.75203V9.73592V9.71982V9.70373V9.68766V9.6716V9.65555V9.63951V9.62348V9.60747V9.59147V9.57549V9.55952V9.54356V9.52762V9.51169V9.49578V9.47988V9.46399V9.44812V9.43227V9.41643V9.4006V9.38479V9.369V9.35322V9.33746V9.32171V9.30598V9.29027V9.27458V9.2589V9.24323V9.22759V9.21196V9.19635V9.18076V9.16518V9.14962V9.13409V9.11857V9.10306V9.08758V9.07211V9.05667V9.04124V9.02584V9.01045V8.99508V8.97973V8.9644V8.94909V8.93381V8.91854V8.90329V8.88807V8.87286V8.85768V8.84252V8.82737V8.81225V8.79716V8.78208V8.76703V8.752V8.73699V8.722V8.70704V8.6921V8.67718V8.66229V8.64742V8.63257V8.61775V8.60295V8.58817V8.57342V8.5587V8.54399V8.52932V8.51467V8.50004V8.48544V8.47086V8.45631V8.44179V8.42729V8.41282V8.39837V8.38395V8.36956V8.35519V8.34085V8.32654V8.31225V8.298V8.28377V8.26956V8.25539V8.24124V8.22713V8.21304V8.19898V8.18494V8.17094V8.15697V8.14302V8.12911V8.11522V8.10137V8.08754V8.07374V8.05998V8.04624V8.03254V8.01886V8.00522V7.99161V7.97803V7.96448V7.95096V7.93748V7.92402V7.9106V7.89721V7.88386V7.87053V7.85724V7.84398V7.83076V7.81756V7.80441V7.79128V7.77819V7.76513V7.75211V7.73912V7.72617V7.71325V7.70036V7.68751V7.67469V7.66191V7.64917V7.63646V7.62379V7.61115V7.59855V7.58598V7.57345V7.56096V7.54851V7.53609V7.52371V7.51136V7.49906V7.48679V7.47456V7.46236V7.45021V7.43809V7.42601V7.41397V7.40197V7.39001V7.37809V7.3662V7.35436V7.34255V7.33079V7.31906V7.30738V7.29573V7.28413V7.27256V7.26104V7.24956V7.23811V7.22671V7.21535V7.20404V7.19276V7.18153V7.17034V7.15919V7.14808V7.13702V7.126V7.11502V7.10408V7.09319V7.08234V7.07153V7.06077V7.05005V7.03938V7.02875V7.01817V7.00763V6.99713V6.98668V6.97627V6.96591V6.9556V6.94533V6.9351V6.92492V6.91479V6.90471V6.89467V6.88467V6.87473V6.86483V6.85498V6.84517V6.83541V6.8257V6.81604V6.80643V6.79686V6.78734V6.77787V6.76845V6.75908V6.74975V6.74048V6.73125V6.72208V6.71295V6.70387V6.69485V6.68587V6.67694V6.66807V6.65924V6.65047V6.64174V6.63307V6.62445V6.61588V6.60736V6.59889V6.59047V6.58211V6.5738V6.56554V6.55733V6.54918V6.54108V6.53303V6.52504V6.51709V6.50921V6.50137V6.49359V6.48587V6.47819V6.47058V6.46301V6.45551V6.44805V6.44065V6.43331V6.42602V6.41879V6.41161V6.40449V6.39743V6.39042V6.38347V6.37657V6.36973V6.36295V6.35622V6.34956V6.34294V6.33639V6.3299V6.32346V6.31708V6.31076V6.30449V6.29829V6.29214V6.28606V6.28003V6.27406V6.26815V6.2623V6.25651V6.25078V6.24511V6.2395V6.23395V6.22846V6.22303V6.21766V6.21235V6.20711V6.20192V6.1968V6.19174V6.18674V6.1818V6.17693V6.17211V6.16736V6.16267V6.15805V6.15349V6.14899V6.14455V6.14018V6.13587V6.13163V6.12745V6.12333V6.11928V6.11529V6.11137V6.10751V6.10372V6.09999V6.09633V6.09273V6.0892V6.08573V6.08233V6.079V6.07573V6.07253V6.0694V6.06633V6.06333V6.06039V6.05753V6.05473V6.052V6.04934V6.04674V6.04422V6.04176V6.03937V6.03705V6.03479V6.03261V6.03049V6.02845V6.02647V6.02457V6.02273V6.02097V6.01927V6.01764V6.01609V6.0146V6.01319V6.01185V6.01058V6.00937V6.00825V6.00719V6.0062V6.00529V6.00445V6.00368V6.00298V6.00236V6.00181V6.00133V6.00092V6.00059V6.00033V6.00015V6.00004L17.4999 6L18.9999 6.00004V6.00015V6.00033V6.00059V6.00092V6.00133V6.00181V6.00236V6.00298V6.00368V6.00445V6.00529V6.0062V6.00719V6.00825V6.00937V6.01058V6.01185V6.01319V6.0146V6.01609V6.01764V6.01927V6.02097V6.02273V6.02457V6.02647V6.02845V6.03049V6.03261V6.03479V6.03705V6.03937V6.04176V6.04422V6.04674V6.04934V6.052V6.05473V6.05753V6.06039V6.06333V6.06633V6.0694V6.07253V6.07573V6.079V6.08233V6.08573V6.0892V6.09273V6.09633V6.09999V6.10372V6.10751V6.11137V6.11529V6.11928V6.12333V6.12745V6.13163V6.13587V6.14018V6.14455V6.14899V6.15349V6.15805V6.16267V6.16736V6.17211V6.17693V6.1818V6.18674V6.19174V6.1968V6.20192V6.20711V6.21235V6.21766V6.22303V6.22846V6.23395V6.2395V6.24511V6.25078V6.25651V6.2623V6.26815V6.27406V6.28003V6.28606V6.29214V6.29829V6.30449V6.31076V6.31708V6.32346V6.3299V6.33639V6.34294V6.34956V6.35622V6.36295V6.36973V6.37657V6.38347V6.39042V6.39743V6.40449V6.41161V6.41879V6.42602V6.43331V6.44065V6.44805V6.45551V6.46301V6.47058V6.47819V6.48587V6.49359V6.50137V6.50921V6.51709V6.52504V6.53303V6.54108V6.54918V6.55733V6.56554V6.5738V6.58211V6.59047V6.59889V6.60736V6.61588V6.62445V6.63307V6.64174V6.65047V6.65924V6.66807V6.67694V6.68587V6.69485V6.70387V6.71295V6.72208V6.73125V6.74048V6.74975V6.75908V6.76845V6.77787V6.78734V6.79686V6.80643V6.81604V6.8257V6.83541V6.84517V6.85498V6.86483V6.87473V6.88467V6.89467V6.90471V6.91479V6.92492V6.9351V6.94533V6.9556V6.96591V6.97627V6.98668V6.99713V7.00763V7.01817V7.02875V7.03938V7.05005V7.06077V7.07153V7.08234V7.09319V7.10408V7.11502V7.126V7.13702V7.14808V7.15919V7.17034V7.18153V7.19276V7.20404V7.21535V7.22671V7.23811V7.24956V7.26104V7.27256V7.28413V7.29573V7.30738V7.31906V7.33079V7.34255V7.35436V7.3662V7.37809V7.39001V7.40197V7.41397V7.42601V7.43809V7.45021V7.46236V7.47456V7.48679V7.49906V7.51136V7.52371V7.53609V7.54851V7.56096V7.57345V7.58598V7.59855V7.61115V7.62379V7.63646V7.64917V7.66191V7.67469V7.68751V7.70036V7.71325V7.72617V7.73912V7.75211V7.76513V7.77819V7.79128V7.80441V7.81756V7.83076V7.84398V7.85724V7.87053V7.88386V7.89721V7.9106V7.92402V7.93748V7.95096V7.96448V7.97803V7.99161V8.00522V8.01886V8.03254V8.04624V8.05998V8.07374V8.08754V8.10137V8.11522V8.12911V8.14302V8.15697V8.17094V8.18494V8.19898V8.21304V8.22713V8.24124V8.25539V8.26956V8.28377V8.298V8.31225V8.32654V8.34085V8.35519V8.36956V8.38395V8.39837V8.41282V8.42729V8.44179V8.45631V8.47086V8.48544V8.50004V8.51467V8.52932V8.54399V8.5587V8.57342V8.58817V8.60295V8.61775V8.63257V8.64742V8.66229V8.67718V8.6921V8.70704V8.722V8.73699V8.752V8.76703V8.78208V8.79716V8.81225V8.82737V8.84252V8.85768V8.87286V8.88807V8.90329V8.91854V8.93381V8.94909V8.9644V8.97973V8.99508V9.01045V9.02584V9.04124V9.05667V9.07211V9.08758V9.10306V9.11857V9.13409V9.14962V9.16518V9.18076V9.19635V9.21196V9.22759V9.24323V9.2589V9.27458V9.29027V9.30598V9.32171V9.33746V9.35322V9.369V9.38479V9.4006V9.41643V9.43227V9.44812V9.46399V9.47988V9.49578V9.51169V9.52762V9.54356V9.55952V9.57549V9.59147V9.60747V9.62348V9.63951V9.65555V9.6716V9.68766V9.70373V9.71982V9.73592V9.75203V9.76816V9.78429V9.80044V9.8166V9.83276V9.84894V9.86514V9.88134V9.89755V9.91377V9.93001V9.94625V9.9625V9.97876V9.99504V10.0113V10.0276V10.0439V10.0602V10.0765V10.0929V10.1092V10.1255V10.1419V10.1582V10.1746V10.191V10.2074V10.2237V10.2401V10.2565V10.2729V10.2894V10.3058V10.3222V10.3386V10.3551V10.3715V10.388V10.4044V10.4209V10.4374V10.4538V10.4703V10.4868V10.5033V10.5198V10.5363V10.5527V10.5692V10.5858V10.6023V10.6188V10.6353V10.6518V10.6683V10.6848V10.7014V10.7179V10.7344V10.7509V10.7675V10.784V10.8005V10.8171V10.8336V10.8502V10.8667V10.8832V10.8998V10.9163V10.9328V10.9494V10.9659V10.9825V10.999V11.0155V11.0321V11.0486V11.0651V11.0817V11.0982V11.1147V11.1313V11.1478V11.1643V11.1808V11.1973V11.2139V11.2304V11.2469V11.2634V11.2799V11.2964V11.3129V11.3294V11.3459V11.3623V11.3788V11.3953V11.4118V11.4282V11.4447V11.4611V11.4776V11.494V11.5105V11.5269V11.5433V11.5597V11.5761V11.5925V11.6089V11.6253V11.6417V11.6581V11.6745V11.6908V11.7072V11.7235V11.7399V11.7562V11.7725V11.7888V11.8051V11.8214V11.8377V11.854V11.8703V11.8865V11.9028V11.919V11.9352V11.9514V11.9676V11.9838V12V15.3787L20.4393 13.9393ZM17.4999 6H18.9999C18.9999 5.17157 18.3284 4.5 17.4999 4.5C16.6715 4.5 15.9999 5.17157 15.9999 6H17.4999Z"
      fill={color}
    />
  </svg>
)

const Camera = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 7C4.34315 7 3 8.34315 3 10V16C3 17.6569 4.34315 19 6 19H18C19.6569 19 21 17.6569 21 16V10C21 8.34315 19.6569 7 18 7H16L15.4558 5.36754C15.1836 4.55086 14.4193 4 13.5585 4H10.4415C9.58066 4 8.81638 4.55086 8.54415 5.36754L8 7H6ZM16 12.5C16 14.7091 14.2091 16.5 12 16.5C9.79086 16.5 8 14.7091 8 12.5C8 10.2909 9.79086 8.5 12 8.5C14.2091 8.5 16 10.2909 16 12.5ZM14.5 12.5C14.5 13.8807 13.3807 15 12 15C10.6193 15 9.5 13.8807 9.5 12.5C9.5 11.1193 10.6193 10 12 10C13.3807 10 14.5 11.1193 14.5 12.5Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

const CameraCircle = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="56" height="56" rx="28" fill={props.fill || 'currentColor'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18 19.6667C15.2386 19.6667 13 21.9052 13 24.6667V34.6667C13 37.4281 15.2386 39.6667 18 39.6667H38C40.7614 39.6667 43 37.4281 43 34.6667V24.6667C43 21.9052 40.7614 19.6667 38 19.6667H34.6667L33.7597 16.9459C33.306 15.5848 32.0322 14.6667 30.5975 14.6667H25.4025C23.9678 14.6667 22.694 15.5848 22.2403 16.9459L21.3333 19.6667H18ZM34.6667 28.8333C34.6667 32.5152 31.6819 35.5 28 35.5C24.3181 35.5 21.3333 32.5152 21.3333 28.8333C21.3333 25.1514 24.3181 22.1667 28 22.1667C31.6819 22.1667 34.6667 25.1514 34.6667 28.8333ZM32.1667 28.8333C32.1667 31.1345 30.3012 33 28 33C25.6988 33 23.8333 31.1345 23.8333 28.8333C23.8333 26.5321 25.6988 24.6667 28 24.6667C30.3012 24.6667 32.1667 26.5321 32.1667 28.8333Z"
      fill="white"
    />
  </svg>
)

const BusinessAccount = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3C2 1.89543 2.89543 1 4 1H14C15.1046 1 16 1.89543 16 3V7H20C21.1046 7 22 7.89543 22 9V21C22 22.1046 21.1046 23 20 23H16H4C2.89543 23 2 22.1046 2 21V3ZM5 4.5C5 4.22386 5.22386 4 5.5 4H7.5C7.77614 4 8 4.22386 8 4.5V7.5C8 7.77614 7.77614 8 7.5 8H5.5C5.22386 8 5 7.77614 5 7.5V4.5ZM10 4.5C10 4.22386 10.2239 4 10.5 4H12.5C12.7761 4 13 4.22386 13 4.5V7.5C13 7.77614 12.7761 8 12.5 8H10.5C10.2239 8 10 7.77614 10 7.5V4.5ZM5.5 10C5.22386 10 5 10.2239 5 10.5V13.5C5 13.7761 5.22386 14 5.5 14H7.5C7.77614 14 8 13.7761 8 13.5V10.5C8 10.2239 7.77614 10 7.5 10H5.5ZM10 10.5C10 10.2239 10.2239 10 10.5 10H12.5C12.7761 10 13 10.2239 13 10.5V13.5C13 13.7761 12.7761 14 12.5 14H10.5C10.2239 14 10 13.7761 10 13.5V10.5ZM16.5 10C16.2239 10 16 10.2239 16 10.5V13.5C16 13.7761 16.2239 14 16.5 14H18.5C18.7761 14 19 13.7761 19 13.5V10.5C19 10.2239 18.7761 10 18.5 10H16.5ZM5 16.5C5 16.2239 5.22386 16 5.5 16H7.5C7.77614 16 8 16.2239 8 16.5V19.5C8 19.7761 7.77614 20 7.5 20H5.5C5.22386 20 5 19.7761 5 19.5V16.5ZM10.5 16C10.2239 16 10 16.2239 10 16.5V19.5C10 19.7761 10.2239 20 10.5 20H12.5C12.7761 20 13 19.7761 13 19.5V16.5C13 16.2239 12.7761 16 12.5 16H10.5ZM16 16.5C16 16.2239 16.2239 16 16.5 16H18.5C18.7761 16 19 16.2239 19 16.5V19.5C19 19.7761 18.7761 20 18.5 20H16.5C16.2239 20 16 19.7761 16 19.5V16.5Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

const Switch = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12.6667 4.33077L8.0001 4.33077C6.15915 4.33077 4.00008 4.33077 4.00008 4.33077M12.6667 4.33077L10.0001 1.66406M12.6667 4.33077L10.0001 6.9974"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33337 11.6653H8.00002C9.84097 11.6653 12 11.6653 12 11.6653M3.33337 11.6653L6.00004 14.332M3.33337 11.6653L6.00004 8.9987"
      stroke={props.stroke || 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Location = ({ color = 'currentColor', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.42161 5.46642C8.64482 4.20103 10.2928 3.49994 12 3.49994C13.7072 3.49994 15.3551 4.20103 16.5784 5.46642C17.8032 6.73354 18.5 8.46263 18.5 10.2758C18.5 12.474 17.3362 14.6444 15.7841 16.5297C14.4413 18.1606 12.9246 19.4361 12 20.1465C11.0753 19.4361 9.55869 18.1606 8.21588 16.5297C6.66373 14.6444 5.49998 12.474 5.49998 10.2758C5.49998 8.46263 6.19673 6.73353 7.42161 5.46642ZM12 0.499939C9.4637 0.499939 7.04202 1.54269 5.26465 3.38135C3.48895 5.21828 2.49998 7.69918 2.49998 10.2758C2.49998 13.4952 4.16978 16.3352 5.89985 18.4365C7.65129 20.5638 9.62548 22.1291 10.5721 22.8264C11.4239 23.4538 12.5761 23.4538 13.4278 22.8264C14.3745 22.1291 16.3487 20.5638 18.1001 18.4365C19.8302 16.3352 21.5 13.4952 21.5 10.2758C21.5 7.69918 20.511 5.21828 18.7353 3.38135C16.9579 1.54269 14.5363 0.499939 12 0.499939ZM14.5 9.99994C14.5 11.3807 13.3807 12.4999 12 12.4999C10.6193 12.4999 9.49998 11.3807 9.49998 9.99994C9.49998 8.61923 10.6193 7.49994 12 7.49994C13.3807 7.49994 14.5 8.61923 14.5 9.99994Z"
      fill={color}
    />
  </svg>
)

const Activity = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <circle cx="12" cy="12" r="10.5" stroke="currentColor" strokeWidth="3" />
      <path
        d="M11.5 7.5V12.5L15.5 14.5"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

const Upload = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect width="56" height="56" rx="28" fill={props.fill || 'currentColor'} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.92 20.584a2 2 0 102.828 2.829L26 20.16v12.505a2 2 0 004 0V20.16l3.253 3.253a2 2 0 102.828-2.829l-6.667-6.666a2 2 0 00-2.828 0l-6.667 6.666zm-.587 10.747a2 2 0 10-4 0v4a7.333 7.333 0 007.334 7.333h10.666a7.333 7.333 0 007.334-7.333v-4a2 2 0 10-4 0v4a3.333 3.333 0 01-3.334 3.333H22.668a3.333 3.333 0 01-3.334-3.333v-4z"
      fill="#fff"
    />
  </svg>
)
const Globe = ({ color = 'currentColor', ...props }: React.SVGAttributes<SVGElement>) => {
  const def = useUniqueDef()
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath={def.url}>
        <circle cx="12" cy="12" r="10.5" stroke={color} strokeWidth="3" />
        <line x1="1" y1="11.5" x2="22" y2="11.5" stroke={color} strokeWidth="3" />
        <path
          d="M15.5 12C15.5 15.1652 14.9626 17.9603 14.1509 19.9084C13.7437 20.8857 13.297 21.5786 12.8776 22.0043C12.4635 22.4247 12.1678 22.5 12 22.5C11.8322 22.5 11.5365 22.4247 11.1224 22.0043C10.703 21.5786 10.2563 20.8857 9.84908 19.9084C9.0374 17.9603 8.5 15.1652 8.5 12C8.5 8.83484 9.0374 6.03968 9.84908 4.09164C10.2563 3.11435 10.703 2.4214 11.1224 1.99569C11.5365 1.57528 11.8322 1.5 12 1.5C12.1678 1.5 12.4635 1.57528 12.8776 1.99569C13.297 2.4214 13.7437 3.11435 14.1509 4.09164C14.9626 6.03968 15.5 8.83484 15.5 12Z"
          stroke={color}
          strokeWidth="3"
        />
      </g>
      <defs>
        <clipPath id={def.id}>
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

const Sketch = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M4.50001 5.25027C4.50001 5.25027 3.71496 6.75027 5.25001 6.75027C6.78507 6.75027 9.51787 3.85739 9.75001 5.25027C9.98216 6.64315 3.7937 12.8761 5.25001 13.5003C6.70633 14.1244 15.375 4.87527 16.125 7.87527C16.875 10.8753 6.37501 18.3753 8.25001 19.5003C10.125 20.6253 19.5 15.3753 19.5 11.6253"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

const Star = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="34" height="33" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.207 1.134c.733-1.487 2.853-1.487 3.587 0l3.619 7.333a2 2 0 0 0 1.505 1.094l8.093 1.176c1.64.238 2.295 2.254 1.108 3.411l-5.855 5.708a2 2 0 0 0-.576 1.77l1.383 8.06c.28 1.634-1.435 2.88-2.902 2.109l-7.238-3.806a2 2 0 0 0-1.862 0l-7.238 3.806c-1.467.771-3.182-.475-2.902-2.109l1.383-8.06a2 2 0 0 0-.575-1.77L.88 14.148c-1.187-1.157-.532-3.173 1.108-3.411l8.093-1.176a2 2 0 0 0 1.505-1.094l3.62-7.333z"
      fill="currentColor"
    />
  </svg>
)

const SplitPayment = ({ stroke = 'white', ...props }: React.SVGAttributes<SVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="15.6" cy="15.6996" r="14.1" fill="#00D64F" stroke={stroke} strokeWidth="3" />
    <path
      d="M7.76138 15.8288C7.76138 15.8288 7.17703 15.8288 10.6831 15.8288C13.2105 15.8288 13.1583 13.242 14.7735 12.0305C15.9422 11.154 17.3277 11.4462 19.4483 11.4462"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M7.76141 15.827H10.6831C13.2105 15.827 13.1583 18.4138 14.7736 19.6253C15.9423 20.5018 17.3278 20.2096 19.4483 20.2096"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.5718 18.167L20.3249 20.2122L18.5718 22.2574"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.5718 9.40039L20.3249 11.4456L18.5718 13.4908"
      stroke={stroke}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const Sort = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.53033 2.46985C5.23743 2.17696 4.76257 2.17696 4.46967 2.46985L1.96967 4.96981C1.67678 5.2627 1.67677 5.73757 1.96967 6.03047C2.26256 6.32336 2.73743 6.32337 3.03033 6.03048L4.25 4.81082V10C4.25 10.4142 4.58579 10.75 5 10.75C5.41421 10.75 5.75 10.4142 5.75 10V4.81082L6.96967 6.03048C7.26257 6.32337 7.73744 6.32336 8.03033 6.03047C8.32322 5.73757 8.32322 5.2627 8.03032 4.96981L5.53033 2.46985ZM11.75 6C11.75 5.58579 11.4142 5.25 11 5.25C10.5858 5.25 10.25 5.58579 10.25 6V11.1897L9.03033 9.97009C8.73743 9.6772 8.26256 9.67721 7.96967 9.9701C7.67677 10.263 7.67678 10.7379 7.96967 11.0308L10.4697 13.5307C10.7626 13.8236 11.2374 13.8236 11.5303 13.5307L14.0303 11.0308C14.3232 10.7379 14.3232 10.263 14.0303 9.9701C13.7374 9.67721 13.2626 9.6772 12.9697 9.97009L11.75 11.1897V6Z"
      fill="currentColor"
    />
  </svg>
)
export const Control = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.75 3C6.75 2.58579 6.41421 2.25 6 2.25C5.58579 2.25 5.25 2.58579 5.25 3V3.25H2C1.58579 3.25 1.25 3.58579 1.25 4C1.25 4.41421 1.58579 4.75 2 4.75H5.25V5C5.25 5.41421 5.58579 5.75 6 5.75C6.41421 5.75 6.75 5.41421 6.75 5V4V3ZM11.25 8C11.25 7.58579 11.5858 7.25 12 7.25H14C14.4142 7.25 14.75 7.58579 14.75 8C14.75 8.41421 14.4142 8.75 14 8.75H12C11.5858 8.75 11.25 8.41421 11.25 8ZM9 3.25C8.58579 3.25 8.25 3.58579 8.25 4C8.25 4.41421 8.58579 4.75 9 4.75H14C14.4142 4.75 14.75 4.41421 14.75 4C14.75 3.58579 14.4142 3.25 14 3.25H9ZM1.25 8C1.25 7.58579 1.58579 7.25 2 7.25H8.25V7C8.25 6.58579 8.58579 6.25 9 6.25C9.41421 6.25 9.75 6.58579 9.75 7V8V9C9.75 9.41421 9.41421 9.75 9 9.75C8.58579 9.75 8.25 9.41421 8.25 9V8.75H2C1.58579 8.75 1.25 8.41421 1.25 8ZM2 11.25C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H4.25V13C4.25 13.4142 4.58579 13.75 5 13.75C5.41421 13.75 5.75 13.4142 5.75 13V12V11C5.75 10.5858 5.41421 10.25 5 10.25C4.58579 10.25 4.25 10.5858 4.25 11V11.25H2ZM7.25 12C7.25 11.5858 7.58579 11.25 8 11.25H14C14.4142 11.25 14.75 11.5858 14.75 12C14.75 12.4142 14.4142 12.75 14 12.75H8C7.58579 12.75 7.25 12.4142 7.25 12Z"
      fill="currentColor"
    />
  </svg>
)

export const Verified = (props: React.SVGAttributes<SVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M36.24 4.291a5 5 0 0 1 7.52 0l4.885 5.575a5 5 0 0 0 4.539 1.644l7.22-1.137a5 5 0 0 1 5.778 4.861l.114 7.349a5 5 0 0 0 2.415 4.203l6.374 3.847a5 5 0 0 1 1.302 7.428l-4.612 5.693a5 5 0 0 0-.842 4.775l2.4 6.969a5 5 0 0 1-3.763 6.533l-7.288 1.435a5 5 0 0 0-3.703 3.116l-2.606 6.8a5 5 0 0 1-7.104 2.578l-6.434-3.587a5 5 0 0 0-4.87 0l-6.434 3.587a5 5 0 0 1-7.104-2.577l-2.606-6.8a5 5 0 0 0-3.703-3.117L10.43 62.03a5 5 0 0 1-3.762-6.533l2.399-6.97a5 5 0 0 0-.842-4.774L3.613 38.06a5 5 0 0 1 1.302-7.428l6.374-3.847a5 5 0 0 0 2.415-4.203l.114-7.349a5 5 0 0 1 5.778-4.861l7.22 1.137a5 5 0 0 0 4.539-1.644l4.884-5.575z"
      fill="#39F"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M54.84 31.41a3.75 3.75 0 0 1 0 5.304L37.963 53.59a3.75 3.75 0 0 1-5.303 0l-7.5-7.5a3.75 3.75 0 0 1 5.303-5.303l4.849 4.848 14.223-14.223a3.75 3.75 0 0 1 5.303 0z"
      fill="#fff"
    />
  </svg>
)

export const Avatar = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm5.057 13.557c.924.693 1.538 1.54 1.8 2.443H5.143c.262-.904.876-1.75 1.8-2.443C8.202 15.613 9.986 15 12 15c2.014 0 3.798.613 5.057 1.557ZM12 13c-2.405 0-4.62.73-6.257 1.957C4.106 16.185 3 17.957 3 20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1c0-2.042-1.106-3.815-2.743-5.043C16.62 13.73 14.405 13 12 13Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const Fingerprint = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.19 5.101c.794-.133 1.213-.136 1.994 0h.002a7.052 7.052 0 0 1 4.544 2.812 6.684 6.684 0 0 1 1.166 5.091 22.491 22.491 0 0 1-1.443 4.83 1 1 0 1 0 1.84.783 24.493 24.493 0 0 0 1.571-5.259 8.685 8.685 0 0 0-1.51-6.613 9.052 9.052 0 0 0-5.83-3.616c-1.014-.175-1.66-.168-2.664 0a1 1 0 1 0 .33 1.972Zm2.597 2.196a4.6 4.6 0 0 0-2.857-.294 4.869 4.869 0 0 0-2.52 1.441A5.182 5.182 0 0 0 7.1 11.071v.002a11.468 11.468 0 0 1-2.227 5.033 1 1 0 0 0 1.579 1.227 13.468 13.468 0 0 0 2.617-5.91c.109-.61.39-1.172.803-1.612a2.87 2.87 0 0 1 1.482-.853c.55-.12 1.113-.06 1.617.165a2.71 2.71 0 0 1 1.23 1.117 1 1 0 0 0 1.727-1.008 4.71 4.71 0 0 0-2.14-1.935Zm-.774 5.044a1 1 0 1 0-1.97-.35c-.197 1.116-.624 1.905-1.294 3.096a1 1 0 0 0 1.743.98c.662-1.178 1.257-2.237 1.521-3.726Zm3.68 1.306a1 1 0 1 0-1.97-.35c-.39 2.194-1.481 4.116-3.123 6.057a1 1 0 1 0 1.527 1.292c1.779-2.103 3.093-4.34 3.566-6.999Zm-8.82-7.486a1 1 0 1 0-1.054-1.7c-1.137.705-1.659 1.472-2.284 2.391l-.008.013c-.716 1.052-1.296 2.614-1.511 3.82a1 1 0 1 0 1.969.351c.173-.974.662-2.262 1.196-3.047.62-.913.941-1.362 1.691-1.828Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const Plug = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="24"
    height="24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 2a1 1 0 0 1 1 1v2h4V3a1 1 0 1 1 2 0v2h1a1 1 0 0 1 1 1v4a6.002 6.002 0 0 1-5 5.917V22a1 1 0 1 1-2 0v-6.083A6.002 6.002 0 0 1 6 10V6a1 1 0 0 1 1-1h1V3a1 1 0 0 1 1-1Zm6 5H8v3a4 4 0 0 0 8 0V7h-1Z"
      fill="currentColor"
    ></path>
  </svg>
)

// This is the 16 size DeliveryIcon from Arcade
export const Truck = (props: React.SVGAttributes<SVGElement>) => (
  <svg
    width="16"
    height="16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-hidden="true"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.583 3.576A1.75 1.75 0 0 1 4.281 2.25h7.332a1.75 1.75 0 0 1 1.66 2.303L12.54 6.75h.184a2.75 2.75 0 0 1 2.609 3.62l-.623 1.867a.75.75 0 0 1-.711.513h-1.145a2 2 0 0 1-3.71 0h-2.79a2 2 0 0 1-3.71 0H1a.75.75 0 0 1 0-1.5h12.46l.451-1.355a1.25 1.25 0 0 0-1.186-1.645H11.5a.75.75 0 0 1-.712-.987l1.062-3.184a.25.25 0 0 0-.237-.329H4.28a.25.25 0 0 0-.243.19l-.31 1.242a.75.75 0 1 1-1.456-.364l.311-1.242ZM1.25 8.5A.75.75 0 0 1 2 7.75h5a.75.75 0 1 1 0 1.5H2a.75.75 0 0 1-.75-.75Z"
      fill="currentColor"
    ></path>
  </svg>
)

export const ICONS = {
  avatar: Avatar,
  activity: Activity,
  alert: AlertIcon,
  appSwitch: AppSwitch,
  bag: Bag,
  bank: Bank,
  businessAccount: BusinessAccount,
  calendar: Calendar,
  'calendar-square': CalendarSquare,
  camera: Camera,
  'camera-circle': CameraCircle,
  card: Card,
  'cash-app-taxes': CashAppTaxes,
  'cash-dollar': CashDollar,
  chat: Chat,
  check: Check,
  checkMark: CheckMark,
  'checkmark-circle': CheckmarkCircle,
  'chevron-down': ChevronDown,
  clock: Activity,
  control: Control,
  desktop: Desktop,
  'desktop-circle': DesktopCircle,
  dollar: Dollar,
  ellipsis: Ellipsis,
  error: ErrorIcon,
  eyeClosed: EyeClosed,
  eyeOpen: EyeOpen,
  failed: Failed,
  fdic: Fdic,
  file: File,
  fingerprint: Fingerprint,
  globe: Globe,
  help: Help,
  info: Info,
  lightning: Lightning,
  'lightning-circle': LightningCircle,
  link: Link,
  'link-out': LinkOut,
  location: Location,
  lock: Lock,
  'lock-circle': LockCircle,
  menu: Menu,
  minus: Minus,
  'no-fees': NoFees,
  'nav-help': NavHelp,
  numeral1: Numeral1,
  numeral2: Numeral2,
  numeral3: Numeral3,
  pencil: Pencil,
  phone: Phone,
  plane: Plane,
  plug: Plug,
  plus: Plus,
  'price-tag': PriceTag,
  search: Search,
  share: Share,
  sketch: Sketch,
  star: Star,
  switch: Switch,
  sort: Sort,
  taxes: Taxes,
  transfer: Transfer,
  trash: Trash,
  truck: Truck,
  upload: Upload,
  verification: Verification,
  'split-payment': SplitPayment,
  verified: Verified,
} as const

export type IconProps = {
  name: keyof typeof ICONS
}

/**
 * Legacy / mooncake Icon Component.
 *
 * Renders a square sized svg icon element. The size of this component is controlled by the font size of the parent element (1em).
 * Any additional props are passed to the underlying SVG element. There is no wrapper continer element.
 *
 * @param name - The name of the icon to render, must be a valid key in the IconProps.name ICONS list.
 *
 * @deprecated Use icons from `@arcade/web/icons/react` - See go/arcadeweb for more. Please don't add more icons to this class.
 */
export const Icon = ({ name, ...rest }: IconProps & React.SVGAttributes<SVGElement>) => {
  const IconComponent = ICONS[name]

  if (IconComponent == null) {
    throw new Error(`Invalid icon requested: ${name}`)
  }

  return <IconComponent width="1em" height="1em" {...rest} />
}

export function isIconInDesignSystem(iconName: string): iconName is keyof typeof ICONS {
  return iconName in ICONS
}

export default Icon
